function getChatContactList() {
    return new Promise((resolve) => {
        window.connect.agent(function (agent) {
            let chatContacts = agent.getContacts(window.connect.ContactType.CHAT);
            resolve(chatContacts);
        });
    });
}

function getAgentState() {
    return new Promise((resolve) => {
        window.connect.agent(function (agent) {
            let agentState = agent.getState();
            resolve(agentState);
        });
    });
}

export { getChatContactList, getAgentState }